export default __webpack_public_path__ + "static/media/p15.6ce8eae4.jpg";